// Constants
import Colors from 'Wpds/colors/ColorConstants';

// Types
import { CaledndarIntegration2023SlideType } from './types';
import { Illustrations } from 'Wpds/components/illustration';

export const CaledndarIntegration2023Slides: CaledndarIntegration2023SlideType[] = [
  {
    title: 'Create Workspaces',
    heading: 'Create Workspaces',
    image: Illustrations.calendar_integration_2023_onboarding_workspace,
    description:
      'Workspaces are a place to collaborate on agendas and action items & more. Create one for each person you have 1:1’s with.',
    backgroundColor: Colors.purple[100],
  },
  {
    title: 'Invite your team',
    heading: 'Invite your team',
    image: Illustrations.calendar_integration_2023_onboarding_invite_pi,
    description: 'Invite your team and set the expectation that you both should add to the agenda before each meeting.',
    backgroundColor: Colors.green[100],
  },
  {
    title: 'Use for your next 1:1 ',
    heading: 'Use PI Perform for your next 1:1',
    image: Illustrations.calendar_integration_2023_onboarding_use,
    description:
      'When you meet, have PI Perform open and click “Start Meeting” to take meeting notes and action items in real time.',
    backgroundColor: Colors.blue[100],
  },
];

export const CaledndarIntegration2023SlidesInvited: CaledndarIntegration2023SlideType[] = [
  {
    title: 'View your Agenda',
    heading: 'View your Agenda',
    image: Illustrations.calendar_integration_2023_onboarding_workspace,
    description: 'Check out the agenda your coworker has started setting up.',
    backgroundColor: Colors.purple[100],
  },
  {
    title: 'Add to the agenda',
    heading: 'Add to the agenda',
    image: Illustrations.calendar_integration_2023_onboarding_add_to_agenda,
    description: 'Add any topics you need to discuss that are missing from the agenda.',
    backgroundColor: Colors.green[100],
  },
  {
    title: 'Use for your next 1:1 ',
    heading: 'Use PI Perform for your next 1:1',
    image: Illustrations.calendar_integration_2023_onboarding_use,
    description:
      'When you meet, have PI Perform open and click “Start Meeting” to take meeting notes and action items in real time.',
    backgroundColor: Colors.blue[100],
  },
];
